import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=7f0a9421&scoped=true"
import script from "./activityPage.vue?vue&type=script&lang=ts"
export * from "./activityPage.vue?vue&type=script&lang=ts"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=7f0a9421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a9421",
  null
  
)

export default component.exports